import { EstadoLlaveAnual } from "../../bussines/entities/EstadisticasLlave.entity";

export class EstadoLlaveAnualModel implements EstadoLlaveAnual {
    constructor(
        public estado: string,
        public value: number,
        public mes: number
    ) { }

    serialize(): EstadoLlaveAnual {
        return {
            estado: this.estado,
            value: this.value,
            mes: this.mes
        }
    }

    static deserialize(entity: EstadoLlaveAnual): EstadoLlaveAnualModel {
        return new EstadoLlaveAnualModel(
            entity.estado ?? '',
            entity.value ?? 0,
            entity.mes ?? 0
        );
    }
}